<template>
  <div class="login_page" v-loading="loading">
    <div class="login-card">
      <div class="title">员工登录</div>
      <el-form ref="form" :model="form" label-width="80px" v-show="mobileLogin">
        <el-form-item label="手机号">
          <el-input v-model="form.account" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <div class="button-box">
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </div>
      </el-form>
      <!--<div id="wx_reg" v-show="!mobileLogin"></div>-->
      <div class="toggle_login" v-if="false">
        <el-button type="text" class="" @click="()=>{this.mobileLogin = !this.mobileLogin}">
          使用{{ mobileLogin ? '企业微信扫码' : '手机号和密码' }}登录
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import UserApi from '../api/user'
import { CONFIG } from '../config';

export default {
  data () {
    return {
      form: {
        account: '',
        password: ''
      },
      third_id: '',
      mobileLogin: false,
      loading: true
    }
  },
  created () {
    if (CONFIG.isWechat()) {
      if (this.$route.query.code) {
        this.loginByCode()
      } else {
        this.getAuthUrl()
      }
    } else {
      this.mobileLogin = true
    }
  },
  mounted () {
  },
  methods: {
    async getAuthUrl () {
      const res = await UserApi.getAuthUrl()
      if (res.data.code === 1) {
        location.href = res.data.data
      }
    },
    async loginByCode () {
      const res = await UserApi.loginByCode({ code: this.$route.query.code, state: this.$route.query.state })
      if (res.data.code === 1) {
        let uid = res.data.data.user.user_id
        let token = res.data.data.user.token
        this.login_callback(uid, token)
      } else {
        this.third_id = res.data.data.third_id
        this.mobileLogin = true
      }
    },
    login_callback (uid, token) {
      this.$store.commit('setUid', uid)
      localStorage.setItem('uid', uid)
      this.$store.commit('setToken', token)
      localStorage.setItem('token', token)
      this.$store.commit('setIsLogin', 1)
      localStorage.setItem('is_login', 1)
    },
    onSubmit () {
      const params = {
        account: this.form.account,
        password: this.form.password,
        third_id: this.third_id
      }
      UserApi.login(params).then(res => {
        if (res.data.code === 1) {
          let uid = res.data.data.userinfo.user_id
          let token = res.data.data.userinfo.token
          this.login_callback(uid, token)
        } else {
          this.$message.error(res.data.msg || '用户登录失败')
        }
      }).catch(error => {
        if (error.response) {
          this.$message.error(error.response.data.message)
        } else {
          this.$message.error('发生未知错误')
        }
      })
    }
  },
  computed: {
    loginStatus () {
      return this.$store.getters.getIsLogin
    }
  },
  watch: {
    mobileLogin: function (val){
      if(val){
        this.loading = false
      }
    },
    loginStatus: function () {
      if (this.loginStatus === 1) {
        // 使用location.replace而非$router.push，强制整页加载Home页面
        // iOS微信中JSSDK签名使用WebView入口URL，SPA路由跳转不会更新此URL
        // OAuth回调后入口URL带有code/state参数，需通过整页跳转刷新入口URL
        location.replace(CONFIG.TENANT_PATH)
      }
    }
  }
}
</script>
<style lang="scss">
.login_page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%);

  .login-card {
    width: 420px;
    padding: 40px 36px 32px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  }

  .title {
    margin-bottom: 36px;
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    color: #409EFF;
    letter-spacing: 2px;
  }

  .el-form-item {
    margin-bottom: 24px;
  }

  .button-box {
    text-align: center;
    margin-top: 36px;

    .el-button {
      width: 100%;
      height: 42px;
      font-size: 16px;
      letter-spacing: 4px;
    }
  }

  #wx_reg {
    text-align: center;
  }

  .toggle_login {
    text-align: center;
    margin-top: 16px;
  }
}
</style>
